import DateFilters from '@/filters/dateFilters'
import CurrencyFilters from '@/filters/currencyFilters'
import CaseFilters from '@/filters/caseFilters'

export const Filters = {
  date: DateFilters,
  currency: CurrencyFilters,
  case: CaseFilters,
}

export default Filters
